import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const useAuth = () => {
    //get item from localstorage

    let user = "";
    const token = localStorage.getItem("Token");
    
    if (token) {
        user = token;
    }
    
    if (user) {
        return {
            auth: true
        }
    } else {
        return {
            auth: false
        }
    }
}

//protected Route state
// const ProtectedRouteType = {
//     roleRequired: "Admin"// "ADMIN" | "USER"
// }

const ProtectedRoutes = (props, ProtectedRouteType) => {
    const { auth } = useAuth();
  

    var hours = 24; // to clear the localStorage after 1 hour
    // (if someone want to clear after 8hrs simply change hours=8)

    var now = new Date().getTime();

    var setupTime = localStorage.getItem('setupTime');

    if (setupTime == null) {
        localStorage.setItem('setupTime', now)
    } else {
        if (now - setupTime > hours * 60 * 60 * 1000) {
            localStorage.clear()
            localStorage.setItem('setupTime', now);
        }
    }

    return auth ? <Outlet /> : <Navigate to="/login" />
}

export default ProtectedRoutes;